export default __webpack_public_path__ + "static/media/profile.60342fa0.jpg";